import { FractionalTransactionPart, User } from "./../../proto/api_pb.d";

export interface ExploreBaseProps {
  musicNFTs: Array<MusicNFT>;
  isLoading: boolean;
  userProfile?: boolean;
  isTrack: boolean;
  hideFeatured?: boolean;
}

export interface MusicNFT {
  id?: number;
  txnId?: string;
  title: string;
  artist: string;
  description: string;
  image: string;
  song: string;
  price?: number;
  genres: string[];
  timestamp: number;
  contributors: Array<FractionalTransactionPart>;
  ownerId: string;
  state?: number;
}

export interface MusicNftWithPlayingState {
  id?: number;
  title: string;
  artist: string;
  description: string;
  image: string;
  song: string;
  price?: number;
  genres: string[];
  timestamp: number;
  contributors: Array<FractionalTransactionPart>;
  ownerId: string;
  isPlaying: boolean;
  state?: number;
}

export type AutocompleteOption =
  | string
  | {
      firstLetter: string;
      item: string;
    }
  | null;

export interface CardModalProps {
  open: boolean;
  handleClose: () => void;
  nft: MusicNFT;
  handleCreateGroupChat: () => void;
  isTrack: boolean;
}

export interface CardProps {
  nft: MusicNftWithPlayingState;
  allUsers: User[];
  stopAllSongs: () => void;
  handlePlayPause: (id: number) => void;
  isTrack: boolean;
}

export interface NftTrack {
  id: number;
  audio: string | undefined;
  waveSurfer?: WaveSurfer;
  isPlaying: boolean;
  image: string | undefined;
  title: string | undefined;
  subtitle: string | undefined;
  genre: string | undefined;
}

export interface TrackProps {
  track: NftTrack;
  setAudioTrack: (id: number, audioTrack: WaveSurfer) => void;
  handlePlay: (id: number) => void;
  handleStop: (id: number) => void;
}

export const sortOptions = [
  "None",
  "Recently Created",
  "Sort by Title",
  "Sort by Artist",
];

export const sampleData: MusicNFT[] = [
  {
    id: 1,
    title: "Morning Jay",
    artist: "Slumber",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    image: "card1.png",
    price: 500000000000000000,
    song: "test song url",
    genres: ["Electronic"],
    timestamp: 1234,
    contributors: [],
    ownerId: "123",
  },
  {
    id: 2,
    title: "Morning Jay",
    artist: "Slumber",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    image: "card2.png",
    price: 700000000000000000,
    song: "test song url",
    genres: ["Indie"],
    timestamp: 1234,
    contributors: [],
    ownerId: "123",
  },
  {
    id: 3,
    title: "Morning Jay",
    artist: "Slumber",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    image: "card3.png",
    price: 100000000000000000,
    song: "test song url",
    genres: ["Rock"],
    timestamp: 1234,
    contributors: [],
    ownerId: "123",
  },
  {
    id: 4,
    title: "Morning Jay",
    artist: "Slumber",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    image: "card7.png",
    price: 150000000000000000,
    song: "test song url",
    genres: ["Rock"],
    timestamp: 1234,
    contributors: [],
    ownerId: "123",
  },
  {
    id: 5,
    title: "Morning Jay",
    artist: "Slumber",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    image: "card5.png",
    price: 800000000000000000,
    song: "test song url",
    genres: ["Rock"],
    timestamp: 1234,
    contributors: [],
    ownerId: "123",
  },
  {
    id: 6,
    title: "Morning Jay",
    artist: "Slumber",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    image: "card6.png",
    price: 210000000000000000,
    song: "test song url",
    genres: ["Indie"],
    timestamp: 1234,
    contributors: [],
    ownerId: "123",
  },
  {
    id: 7,
    title: "Morning Jay",
    artist: "Slumber",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    image: "card1.png",
    price: 1200000000000000000,
    song: "test song url",
    genres: ["Indie"],
    timestamp: 1234,
    contributors: [],
    ownerId: "123",
  },
  {
    id: 8,
    title: "Morning Jay",
    artist: "Slumber",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
    image: "card4.png",
    price: 200000000000000000,
    song: "test song url",
    genres: ["Electronic"],
    timestamp: 1234,
    contributors: [],
    ownerId: "123",
  },
];
